/**
 * What the site holds from entry for the life of the page (#1809, WS_DESIGN_1809 W3): the `allMids` and
 * `outcomeMetaUpdates` streams and the 24 h volume poll. Mounted once above the routes, so moving between pages neither
 * subscribes nor unsubscribes, and Markets opens from data already here. Behind GeoGate: a blocked visitor opens no socket.
 * A leaf that renders nothing, so its updates re-render nothing else. An env switch moves all three to the new network.
 */
import { useHoldOutcomeMeta } from '../catalog/useOutcomeMeta';
import { useAllMids } from '../hl/mids';
import { useHoldDayVolumes } from '../volume/useVolume';

export default function GlobalStreams() {
  useAllMids();
  useHoldOutcomeMeta();
  useHoldDayVolumes();
  return null;
}
